import { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { CartProvider } from "@/context/CartContext";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";
import RegisterStore from "@/pages/RegisterStore";
import PublicStore from "@/pages/PublicStore";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import OrdersManagement from "@/pages/admin/OrdersManagement";
import SalesStats from "@/pages/admin/SalesStats";
import AdminChat from "@/pages/admin/AdminChat";
import StoreSettings from "@/pages/admin/StoreSettings";
import SuperAdminPanel from "@/pages/admin/SuperAdminPanel";
import PointOfSale from "@/pages/admin/PointOfSale";
import Customers from "@/pages/admin/Customers";
import GerenteLogin from "@/pages/GerenteLogin";
import KitchenDisplay from "@/pages/admin/KitchenDisplay";
import ToolsManager from "@/pages/admin/ToolsManager";

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <Routes>
            {/* Landing Page */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/registro" element={<RegisterStore />} />
            
            {/* Public Store Pages */}
            <Route path="/tienda/:storeDomain" element={<PublicStore />} />
            
            {/* Super Admin */}
            <Route path="/superadmin" element={<SuperAdminPanel />} />
            
            {/* Gerente de Ventas Login */}
            <Route path="/gerentedeventas" element={<GerenteLogin />} />
            
            {/* Store-specific Admin Routes (legacy /admin/:storeDomain) */}
            <Route path="/admin/:storeDomain/login" element={<AdminLogin />} />
            <Route path="/admin/:storeDomain/dashboard" element={<AdminDashboard />} />
            <Route path="/admin/:storeDomain/orders" element={<OrdersManagement />} />
            <Route path="/admin/:storeDomain/stats" element={<SalesStats />} />
            <Route path="/admin/:storeDomain/chat" element={<AdminChat />} />
            <Route path="/admin/:storeDomain/settings" element={<StoreSettings />} />
            <Route path="/admin/:storeDomain/pos" element={<PointOfSale />} />
            <Route path="/admin/:storeDomain/customers" element={<Customers />} />
            <Route path="/admin/:storeDomain" element={<Navigate to="login" replace />} />
            
            {/* Legacy Admin Routes (for demo-store compatibility) */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/admin/orders" element={<OrdersManagement />} />
            <Route path="/admin/stats" element={<SalesStats />} />
            <Route path="/admin/chat" element={<AdminChat />} />
            <Route path="/admin/settings" element={<StoreSettings />} />
            <Route path="/admin/pos" element={<PointOfSale />} />
            <Route path="/admin/customers" element={<Customers />} />
            <Route path="/admin/kitchen" element={<KitchenDisplay />} />
            <Route path="/admin/tools" element={<ToolsManager />} />
            <Route path="/admin" element={<Navigate to="/admin/login" replace />} />

            {/* Custom admin path routes (e.g., /admin123/login, /panelventas/dashboard) */}
            <Route path="/:adminPath/login" element={<AdminLogin />} />
            <Route path="/:adminPath/dashboard" element={<AdminDashboard />} />
            <Route path="/:adminPath/orders" element={<OrdersManagement />} />
            <Route path="/:adminPath/stats" element={<SalesStats />} />
            <Route path="/:adminPath/chat" element={<AdminChat />} />
            <Route path="/:adminPath/settings" element={<StoreSettings />} />
            <Route path="/:adminPath/pos" element={<PointOfSale />} />
            <Route path="/:adminPath/customers" element={<Customers />} />
            <Route path="/:adminPath/kitchen" element={<KitchenDisplay />} />
            <Route path="/:adminPath/tools" element={<ToolsManager />} />
            <Route path="/:adminPath" element={<Navigate to="login" replace />} />
          </Routes>
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
